/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SectionAnswer,
    SectionAnswerFromJSON,
    SectionAnswerFromJSONTyped,
    SectionAnswerToJSON,
} from './';

/**
 * 
 * @export
 * @interface SectionQuestion
 */
export interface SectionQuestion {
    /**
     * 
     * @type {string}
     * @memberof SectionQuestion
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SectionQuestion
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SectionQuestion
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof SectionQuestion
     */
    placeholder?: string;
    /**
     * 
     * @type {Array<SectionAnswer>}
     * @memberof SectionQuestion
     */
    answers?: Array<SectionAnswer>;
}

export function SectionQuestionFromJSON(json: any): SectionQuestion {
    return SectionQuestionFromJSONTyped(json, false);
}

export function SectionQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionQuestion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'placeholder': !exists(json, 'placeholder') ? undefined : json['placeholder'],
        'answers': !exists(json, 'answers') ? undefined : ((json['answers'] as Array<any>).map(SectionAnswerFromJSON)),
    };
}

export function SectionQuestionToJSON(value?: SectionQuestion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'text': value.text,
        'placeholder': value.placeholder,
        'answers': value.answers === undefined ? undefined : ((value.answers as Array<any>).map(SectionAnswerToJSON)),
    };
}


